<template>
  <div :class="containerClass">
    <a
      class="row post-card q-pa-md border-radius-0"
      :href="post.publicUrl"
    >
      <div class="col-3">
        <div class="fs-20 q-mb-md">{{ post.title }}</div>
        <div class="post-date fs-12 q-mb-sm">
          {{ dayjs.unix(post.createdAt.timestamp).format('DD.MM.YYYY') }}
          {{ dayjs.unix(post.createdAt.timestamp).format('HH:mm') }}
        </div>
      </div>
      <div class="col q-px-md post-content">
        <div v-html="description" />
      </div>
      <div class="col-4">
        <img
          :src="cover"
          :alt="post.metaFields.coverImageAlt"
          loading="lazy"
          class="full-width"
        >
      </div>
    </a>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import { computed } from 'vue';
import getThumb from 'src/helpers/getThumb';
import { useQuasar } from 'quasar';

const $q = useQuasar();

const props = defineProps({
  containerClass: {
    type: String,
    default: 'q-pa-sm',
  },
  post: {
    type: Object,
    default: () => ({}),
  },
});

const width = $q.platform.is.mobile ? 330 : 500;
const height = $q.platform.is.mobile ? 240 : 250;

const cover = computed(() => {
  if (!props.post.coverImageGuid?.url) {
    return '/empty-blog-cover.png';
  }

  return getThumb(props.post.coverImageGuid?.url, width, height);
});
const description = computed(() => props.post.metaFields.metaDescription || props.post.excerptContent);
</script>

<style lang="scss" scoped>
.post-card {
  background: var(--blog-card-color, #fff);
  color: inherit;
  text-decoration: inherit;
}
.post-date,
.post-content {
  opacity: 0.5;
}
.post-date {
  line-height: 12px;
}
.post-title {
  overflow: hidden;
  line-height: 22px;
  height: 44px;
}
.post-content {
  line-height: 20px;
}
.post-card-image {
  object-fit: cover;
}
</style>
